export default class PostViewTrackerController {
    constructor() {
        this.init();
    }

    init() {
        // Get post ID from data attribute or URL
        const postId = this.getPostId();
        
        if (!postId) {
            return; // Not a post detail page
        }

        // Lazy load PostViewTracker class
        import(/* webpackChunkName: "PostViewTracker" */ "../classes/PostViewTracker")
            .then(({ default: PostViewTracker }) => {
                new PostViewTracker(postId);
            })
            .catch(err => console.error('Error loading PostViewTracker:', err));
    }

    /**
     * Get post ID from data attribute or URL
     */
    getPostId() {
        // Try data attribute first (most reliable)
        const section = document.querySelector('.c-post-signle[data-post-id]');
        if (section) {
            const postId = parseInt(section.getAttribute('data-post-id'), 10);
            if (postId && postId > 0) {
                return postId;
            }
        }

        // Fallback: try to extract from URL (san-pham/slug)
        const urlMatch = window.location.pathname.match(/\/san-pham\/([^\/]+)/);
        if (urlMatch) {
            // We can't get ID from slug without API call, so return null
            // The view should provide data-post-id attribute
            return null;
        }

        return null;
    }
}

